<div class="p-4">
  <h2 class="tw-text-xl tw-font-bold tw-mb-6">{{ 'mysec.uploadOtherDocuments' | translate }}</h2>

  <form [formGroup]="form" [class.show-form-error]="showFormError">
    <div class="form-group tw-mb-4">
      <label class="tw-font-semibold">{{ 'mysec.documentName' | translate }}*</label>
      <input
        type="text"
        class="form-control"
        formControlName="fileName"
        placeholder="{{ 'mysec.enterDocumentName' | translate }}"
      />
      <div *ngIf="showFormError && form.get('fileName').invalid" class="tw-text-red-500 tw-text-xs tw-mt-1">
        {{ 'mysec.documentNameRequired' | translate }}
      </div>
    </div>

    <div class="form-group tw-mb-4">
      <label class="tw-font-semibold">{{ 'common.audience' | translate }}*</label>
      <mat-select
        [placeholder]="'common.selectPlaceholder' | translate"
        class="form-control"
        formControlName="audience"
      >
        @for (option of audienceOptions; track option) {
          <mat-option [value]="option.id">
            {{ option.labelKey | translate }}
          </mat-option>
        }
      </mat-select>
      <div *ngIf="showFormError && form.get('audience').invalid" class="tw-text-red-500 tw-text-xs tw-mt-1">
        {{ 'common.audienceRequired' | translate }}
      </div>
    </div>

    <div class="form-group tw-mb-6">
      <label class="tw-font-semibold">{{ 'mysec.uploadDocument' | translate }}*</label>
      <div
        class="upload-zone tw-cursor-pointer tw-rounded-lg tw-border-2 tw-border-dashed tw-p-10 tw-text-center tw-transition-all"
        [ngClass]="{
          'tw-border-blue-500 tw-bg-blue-50': !isDragging,
          'tw-border-green-500 tw-bg-green-100 tw-scale-105': isDragging,
          'tw-border-red-300': showFormError && !document.file,
        }"
        (click)="fileInput.click()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <input
          #fileInput
          type="file"
          [accept]="accept"
          class="tw-hidden"
          (change)="onFileChange($event)"
        />

        @if (!isLoading) {
          <div>
            <div class="tw-mb-2">
              <i
                class="fa fa-cloud-upload tw-text-3xl"
                [ngClass]="document.file ? 'tw-text-green-500' : 'tw-text-blue-500'"
              ></i>
            </div>
            <p class="tw-text-blue-600 tw-mb-1 tw-font-bold">
              {{ document.file ? 'File Selected' : 'Click or Drag file to upload' }}
            </p>
            <p class="tw-break-all tw-text-sm tw-italic tw-text-gray-500">
              {{ document.file ? document.file.name : 'PDF only, max 30MB' }}
            </p>
          </div>
        } @else {
          <div class="tw-py-2">
            <div class="spinner-border tw-text-blue-600" role="status"></div>
            <p class="tw-text-blue-600 tw-mt-2 tw-text-sm tw-font-medium">{{ 'mysec.processingFile' | translate }}</p>
          </div>
        }
      </div>
      <div *ngIf="showFormError && !document.file" class="tw-text-red-500 tw-text-xs tw-mt-1">
        {{ 'mysec.pleaseUploadDocument' | translate }}
      </div>
      @if (showFormError && !document.file) {
        <div class="tw-text-red-500 tw-mt-1 tw-text-xs">Please upload a document.</div>
      }
    </div>

    <div class="tw-flex tw-justify-end tw-gap-4 tw-mt-8">
      <button
        type="button"
        class="btn btn-link tw-text-gray-500 tw-no-underline"
        (click)="cancel()">
        {{ 'common.cancel' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-danger tw-bg-red-700 tw-text-white tw-px-8 tw-rounded tw-font-semibold hover:tw-bg-red-800"
        [disabled]="isLoading"
        (click)="confirm()">
        {{ 'common.confirm' | translate }}
      </button>
    </div>
  </form>
</div>
